import React, { createRef } from 'react';
import LabSimService, { StateContext } from '../services/LabSimService';
import LoadingPage from './LoadingPage';
import ErrorPage from './ErrorPage';
import SuccessPage from './SuccessPage';
import ResourceHelper from '../helpers/ResourceHelper';
import { Routes } from '../Routing';
export default React.forwardRef((props, ref) => (React.createElement(StateContext.Consumer, null, (stateContext) => (React.createElement(CreateAssignments, Object.assign({}, props, { context: stateContext }))))));
class CreateAssignments extends React.Component {
    constructor(props) {
        super(props);
        this.contentItemsSubmitRef = createRef();
        this.createCallback = (response) => {
            this.setState({ inProgress: false, response: response, redirectUrl: response.redirectUrl }, () => {
                var _a;
                if (response.responseType === 2) {
                    (_a = this.contentItemsSubmitRef.current) === null || _a === void 0 ? void 0 : _a.click();
                }
            });
        };
        if (props.location.state) {
            const selectedResources = props.location.state
                .selectedResources;
            const currentProduct = props.location.state
                .product;
            if (!currentProduct || !selectedResources) {
                // verify required route data exists
                alert('Invalid route state. Now redirecting you to products.');
                this.props.history.push(Routes.BROWSE);
            }
            this.state = {
                inProgress: true,
                response: undefined,
            };
        }
    }
    componentDidMount() {
        this.createCallback = this.createCallback.bind(this);
        if (this.props.location.state) {
            const selectedProduct = this.props.location.state
                .product;
            const publish = this.props.location.state.publish;
            const selectedResources = this.props.location.state
                .selectedResources;
            // Sort selected resources by section number so that assignments are created in the right order
            selectedResources.sort(ResourceHelper.sortSectionNumbers);
            const resourceList = selectedResources.map((resource) => {
                return {
                    allowedAttempts: -1,
                    assignmentGroup: resource.assignmentGroup,
                    assignmentType: resource.addGradeColumn ? 'resource' : 'link',
                    isGraded: resource.addGradeColumn,
                    moduleGroup: resource.moduleGroup,
                    pointsPossible: resource.addGradeColumn ? resource.possiblePoints || 1 : 0,
                    resourceGuid: resource.resourceGuid,
                    sectionName: resource.sectionTitle,
                    sectionNumber: resource.sectionNumber,
                };
            });
            const resourceAssignments = {
                isPublish: publish,
                productVersionId: selectedProduct.productVersionId,
                resources: resourceList,
                state: this.props.context.stateId,
            };
            // Create assignments on Canvas and redirect back to main page
            LabSimService.createResourceAssignments(resourceAssignments, (data) => this.createCallback(data), (error) => {
                this.setState({
                    response: {
                        error: error,
                    },
                    inProgress: false,
                });
            });
        }
    }
    goHomeOrRedirect() {
        // d2l preferred workflow is to close out everything once we are done building
        if (this.props.context.isFamilyDesire2Learn()) {
            if (this.state.redirectUrl !== null &&
                this.state.redirectUrl !== 'undefined' &&
                this.state.redirectUrl !== null) {
                // @ts-ignore
                window.location = this.state.redirectUrl;
                return;
            }
        }
        this.props.history.push(Routes.HOME);
    }
    render() {
        if (this.state.inProgress) {
            return React.createElement(LoadingPage, { status: 'Creating links to selected assignments' });
        }
        if (this.state.response != null && !this.state.response.isValid) {
            return (React.createElement(ErrorPage, { failedAction: 'We had some trouble creating links for you.', errorMsg: this.state.response.error }));
        }
        else {
            if (this.state.response != null && this.state.response.responseType === 2) {
                return (React.createElement("form", { name: 'contentItems', method: 'POST', action: this.state.response.redirectUrl },
                    React.createElement("input", { type: 'hidden', value: this.state.response.jwt, id: 'JWT', name: 'JWT' }),
                    React.createElement("input", { type: 'submit', value: 'Post', ref: this.contentItemsSubmitRef, hidden: true })));
            }
            const selectedResources = this.props.location.state
                .selectedResources;
            const onlyModules = selectedResources.filter((resource) => resource.isGradable).length === 0;
            const moreInfoTxt = !onlyModules ? (React.createElement(React.Fragment, null,
                "Graded assignments are listed in ",
                React.createElement("i", null, "Assignments"),
                ", while ungraded assignments are in ",
                React.createElement("i", null, "Modules"),
                ".")) : (React.createElement(React.Fragment, null,
                "Go to ",
                React.createElement("i", null, "Modules"),
                " to find the link to CertMaster."));
            return (React.createElement(SuccessPage, { successAction: React.createElement(React.Fragment, null, "CertMaster\u2122 Assignments Created"), moreInfo: moreInfoTxt, onClickCallback: () => this.goHomeOrRedirect() }));
        }
    }
}
//# sourceMappingURL=CreateAssignments.js.map